// @flow strict
import React from "react";
import type { Node as ReactNode } from "react";
import type { Edge } from "../../../types";

type Props = {
  edge: Edge,
};

const FeedImage = ({ edge }: Props): ReactNode => {
  const socialImage = edge.node.frontmatter.socialImage;
  const socialImageUrl = socialImage && typeof socialImage.publicURL === "string"
    ? socialImage.publicURL
    : null;

  if (!socialImageUrl) {
    return null;
  }

  return (
    <img
      src={socialImageUrl}
      alt={
        edge.node.frontmatter.title +
        "'s image showing a brief idea of what this post is about."
      }
    />
  );
};

export default FeedImage;
